import React, { useContext, useEffect } from "react";

import HomeSlider from "../slider/Slider";
import Services from "../services/Services";
import OurDevices from "../devices/OurDevices";
import OurProducts from "../products/OurProducts";
import ContactUs from "../contact/ContactUs";
import Partners from "../partners/Partners";

import StayUpdated from "../stayUpdated/StayUpdated";
import WhyUs from "../whyUs/WhyUs";
import Applications from "../apps/Applications";
import BanarAd from "../ads/BanarAd";

import adImgUrl1 from "../../imgs/ads/ad_logo1.png";
import SensorsFull from "../sensors/SensorsFull";
import SmartContainerSolutions from "../smartContainerSolutions/SmartContainerSolutions";
import Brands from "../brands/Brands";
import Achievements from "../whyUs/Achievements";
import { Context } from "../LocalWrapper";

// import CircleCard from "../whyUs/test/CircleCard";

const adHeader1 = '"Advertising area is limited - reserve your space today!"';
const adParagraph1 = '" ! المساحات الإعلانيه محدودة – احجز مساحتك اليوم"';

function Home() {
  const context = useContext(Context);

  return (
    <div>
      <HomeSlider />
      <Brands />

      <BanarAd
        adImgUrl={adImgUrl1}
        adHeader={adHeader1}
        adParagraph={adParagraph1}
      />
      <WhyUs />
      <Services />
      <OurDevices />
      <SmartContainerSolutions />
      {/* <CircleCard /> */}
      <Achievements />
      <OurProducts />
      <SensorsFull />
      <Applications />
      <Partners />
      <ContactUs />
      {!context?.user?.email && <StayUpdated />}
    </div>
  );
}

export default Home;
